import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Project soundtracks - how I killed procrastination",
  "description": "",
  "published": "2013-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/project-soundtracks-how-i-killed-procrastination/swizec/5815"],
  "categories": "Uncategorized",
  "hero": "./img/3278-3003255229_6be9f9575f_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/7903145@N08/3001208621"
      }}><img parentName="a" {...{
          "src": "https://farm4.staticflickr.com/3276/3001208621_ca3187abef.jpg",
          "alt": "Are you procrastinating?",
          "title": "Are you procrastinating?"
        }}></img></a></p>
    <p>{`I am a procrastinator.`}</p>
    <p>{`Everybody who's ever agreed to meet with me can confirm that I am always 5 minutes late. It's not because I'm mean or don't respect people's time, it's because I leave it to the last minute to pry myself away from work and start getting ready.`}</p>
    <p>{`The point is, I procrastinate `}<em parentName="p">{`everything`}</em>{`. I'd start procrastinating five minutes later if I could.`}</p>
    <p>{`It's very bad.`}</p>
    <h2 {...{
      "id": "cure-step-1---pomodoro"
    }}>{`Cure, step 1 - pomodoro`}</h2>
    <p>{`About a year ago `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859"
      }}>{`I started using the Pomodoro technique`}</a>{`to ward off procrastinating while I work. You know, the whole, finish ten lines of code, go online for two minutes, write a bit of code ...`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "300px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a2fa543fec8b9332bacd0870548f2909/f93b5/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M194%20132c-8%201-14%203-15%205l-6%203c-4%203-6%203-20%202l-20%201c-5%202-6%204-3%204%202%201%202%201%200%201h-3l-2%202c-5%202-11%208-19%2017a99%2099%200%2000-21%2051%20209%20209%200%20002%2054l7%2019%209%2016a205%20205%200%200015%2017h-3c-3-2-4-1-2%201%202%201%201%202-1%201-2%200-2%200-2%202%201%201%201%203-1%205v10l-1%202v6c-1%206%200%209%202%205%201-3%202-3%202-2l1%203%201%202h2l3-2c2%200%202%201%202%205%200%2010%200%2010%203%202%201-4%203-5%203-2%201%202%201%202%201%200l1-3v2c0%204%202%208%204%208%201-1%202%200%203%201s1%201%201-1l1-2%201%202%202%202%201%202%201%202v-2l1-3c2%200%202%201%202%205l1%202c2%200%203-3%202-4-1%200%201-4%203-4l1%203c-2%209-2%2010-1%2010%201-1%201-1%201%201-1%202-1%203%201%203v-2l1-4%201-4v2l1%203c2%201%203%201%204-2%200-3%200-3%201%202v7l1%202c1%200%202-2%202-5%201-5%203-8%203-5v3l1%202c0%203%202%201%202-3l2-4c1-1%204%205%204%209%200%203%202%204%203%200a6700%206700%200%20002%201l1-1%201-1v3l1%202%201-3%201-4c1-1%201%201%201%204%200%205%201%205%202%200%201-6%203-5%202%201%200%205%200%205%201%204l2-4c0-7%203-14%203-8l1%203%201%204c-1%203%200%204%201%203l1-2%201-2%201%204c-1%205%200%205%202%201l2-2%201-2c1-5%206-5%207-1%200%205%202%206%202%202l-1-3-1-1c0-1%203-1%204%201v3c0%202%200%202%201%200l1-4v-4l1-2v2l1%203v10l1%201%202-1%201-1-1-1%201-2c1-2%202-2%203%202l2%202v-3c-1-1-1-1%201-1s2%200%202%202l-2%208c3%200%205-4%205-8l1-4%201%203%203%203c1-1%202%201%202%204l1%202%201-1c0-3%202-7%204-7v-2c0-2%200-3%202-4l2-3%201-2v3c0%202%201%203%202%201v3c0%204%200%204%201%203h3c1-2%201-1%201%203l1%203c1%200%204-5%204-8s1-4%202-2v9a256%20256%200%20013%203c1-1%200-2-1-4v-3l1-2%201-2v2c0%203%204%205%206%203%201-2%203%200%203%202-1%201%200%202%201%202%203%201%204%200%202-1-2-2%200-7%202-7l1-3%201-3%201%202%201%203%201-4v-5l1-3c-1-2-1-2%202-1%202%201%202%201%202%203l1%2010c1%202%202-5%202-10-1-3%200-4%201-5v-2l-1-3%202%201c0%202%203%202%203%200l3%202%203%204%205%203-1-2v-8l2-1%202%201c2%200%202%200%201-1-1%200-2-1-2-3v-6c-1-2-1-3%202-3l3-1c0-3%204-6%204-5%201%201%201%200%201-1l3-6v-4c-2-2%200-3%202-1%202%201%204-2%202-4l-2-3c-1-2-3-2-3%201l-1%201-1-3c1-1%200-2-1-3-2%200-1-3%201-5v-1c-2%200-2-1-2-3%200-3%200-3-2-3h-5l-3-1c-1-1-2-2-3-1v-2l2-2a112%20112%200%200018-51v-9c1-11%200-31-1-39a88%2088%200%2000-45-65c-3-2-14-3-27-2h-15c-5-3-22-8-28-9-8-2-15-2-25-1m-29%2086c-1%203%201%207%204%208l2%201%203%201c4-1%205-2%204-7-2-4-12-7-13-3m-14%2047l-2%204c0%202%200%202%203%202%204%200%206%202%204%205-1%201-2%201-3-1-3-2-4-3-4-1s3%205%206%205c6%200%206-8%200-10l-2-1%203-1c5-1%204-2-2-4-2%200-3%200-3%202m60%206l-2%206c-1%207%206%2011%2011%207%203-2%204-10%201-12s-8-2-10-1m2%2051l-5%208-1%202h19l-9-15-4%205\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2fa543fec8b9332bacd0870548f2909/ca0a1/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.webp 223w", "/static/a2fa543fec8b9332bacd0870548f2909/c85cb/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.webp 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2fa543fec8b9332bacd0870548f2909/853b2/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.jpg 223w", "/static/a2fa543fec8b9332bacd0870548f2909/f93b5/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.jpg 300w"],
                "sizes": "(max-width: 300px) 100vw, 300px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a2fa543fec8b9332bacd0870548f2909/f93b5/Italiano-Autore-Francesco-Cirillo-rilasciata319e9i.jpg",
                "alt": "Italiano: Autore: Francesco Cirillo rilasciata...",
                "title": "Italiano: Autore: Francesco Cirillo rilasciata...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Italiano: Autore: Francesco Cirillo rilasciata...`}</figcaption>{`
  `}</figure></p>
    <p>{`You might call it stupidity and bad work habits, but I was procrastinating The Next Step (tm).`}</p>
    <p>{`Pomodoro's 25 minutes of work, 5 minutes of internet right-to-the-vein worked great. For a while at least, I've started slipping up a bit so sometimes it's 27 minutes of work or 7 minutes of internet. But that's okay, it keeps me generally inline.`}</p>
    <p>{`I noticed something far more interesting than a general improvement in work habits.`}</p>
    <p>{`For a while now I can no longer get any work done without a ticking pomodoro timer. The connection between that annoying tik-tak is so strong it's become impossible to focus on a single task when the noise isn't there.`}</p>
    <p>{`Sometimes work would be better without forced breaks - when writing for instance - but I just can't do it. Unless something is ticking I can't keep my grubby little paws off the twitter and facebook and hackernews and so on.`}</p>
    <p>{`With ticking, effortless. It seems whenever the ticking starts I feel an irresistible urge towork. To drop whatever internet buffoonery I'm up to, fire up a code editor and get cracking. As irresistible as hunger.`}</p>
    <p>{`As a result, I've started turning the timer on before I actually start working. Otherwise I would just procrastinate starting until the day was over, but the ticking gets me to stop within a minute or two.`}</p>
    <p>{`Brilliant.`}</p>
    <h2 {...{
      "id": "cure-step-2---project-soundtracks"
    }}>{`Cure, step 2 - project soundtracks`}</h2>
    <p>{`About two months ago I decided to take the concept of training myself in a mad Pavlovian experiment even further.`}</p>
    <p>{`What if I could program myself not only to feel an irresistible urge to work, but an irresistible urge to work on a specific project?`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "240px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e81051c7b239ae85b6336468d8b8e8aa/09b79/3278-3003255229_6be9f9575f_m.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M4%201L2%202C0%202%200%203%200%20135v132h401V134a3606%203606%200%2000-2-93v-7l-1-3-197-1L4%2029l-1-7V10c0-7%201-9%205-8h4l10%201%209-1h7V1l1%201h15c26-1%2019-2-16-2L4%201m272%2033v5l2-1h1c1%201%2021%202%2023%201%202-2%201-4-2-5h-10c-3%201-7%200-11-1l-3%201m33%201c-1%203%201%204%2011%204s11-1%2011-2c0-2-1-3-8-3h-10c-2-1-3%200-4%201m56%200c-1%203%200%204%2014%204%2010%200%2014%200%2015-2%200-2-1-3-4-3h-18c-1-2-6-1-7%201M105%2048l-6%201c-1%201%200%206%202%209l-1%202c-2-1-2-1-2%201l1%205c0%202%200%202%201%201%201-2%201-2%203%200h1c0-2%201-2%203-1%202%202%202-1%201-4s-1-3%201-5c2-1%203-1%203%201l-1%201-1%202%201%201%203%201c2%201%202%201%200%203l-2%202a758%20758%200%2001-8%201l-2%202v1l3%203c1%202%201%202%204%201l3%201c-1%201%201%2012%203%2014l7%204c5%202%205%203%205%205-1%203-1%203%202%203l3-1%201-1c2%200%201%202-2%206-2%204-3%204-5%204-1-1-3%200-4%201h-2l-2-1c-1%201-2%201-1-1l-1-2-1-1c0-2-9-5-12-5-4%200-5%202-5%2011%200%2012%201%2013%204%2013%204-1%205-3%205-7%200-3%201-4%202-4h7c2%201%203%201%203-1h1l3%203c3%201%203%201%207-3%2010-7%2011-8%2013-5%203%204%202%200-1-5-2-5-2-8%200-5%203%202%208%2012%209%2018l7%2015%2012-1%2012-1v-9l-1-9v2h-2c-1-2-2-3-1-4l-2-3v-3c-2%200-2%200-1-1h2c1%202%202-1%202-4-1-2-1-3-2-2l-1%202-1%201-3%202-4%202h-5c-1%201-2%201-3-1l-3-2c-2%200-1%203%201%203l-1%201c-1%201-2%201-1%202l-1%202-1%202-1%201V98c1-2-2-4-7-4-3%200-3%200-1-1%204-1%209-6%209-8%200-3-2-5-2-3v2c-1%202-8%206-9%205s0-2%201-3c1-2%201-2-2-4-3-3-3-3-1-4%204-1%203-4-1-4l-3-1%201-2%203-6-2-3V52c2-3-1-4-11-4l-10%201h-1c-1-1-4-2-12-1m45%204c1%207%202%2010%203%209v-2c-2%200-1-3%201-3l1%202c0%202%200%202%206%202l6%201h2c2-2%202-2%204-1%204%203%206%202%205-1%200-2%201-3%202-3l1-1-2-2-4-2h-3c-1%202-2%202-3%201h-15v-2c0-2%200-2-2-2-3%200-3%200-2%204m242%200l-1%205v3H188v10h203v31c0%2034%200%2036%203%2036%204%200%204-3%204-44%200-35%200-40-2-41-2-2-3-2-4%200m-260%209l-2%202h-1l-1%201c-1-1-14%205-16%207l-1%203%202-1c1-3%204-1%204%203%200%202%201%203%202%203%202%200%202%200%201-3s-1-6%201-6l2%202c0%202%202%203%204%201%201-2-1-5-2-4l-1-1c0-2%204-2%209%201l4%202v-2c0-3%200-3-3-3l-3-1v-1l2-2c0-4-1-4-1-1M98%2085c0%2011%201%2013%204%2013l2%201%202%201%205%201c2%200%202%200-1-5l-5-11a17047%2017047%200%2000-4-9h-3v9M3%20134a140%20140%200%20003%2038l-1-1-1-1v6c0%204%200%204%201%202s1-2%202%200l3%201-1-2v-1h3c2%202%203%201%202-2%200-2%200-2-1-1h-2c-1-1-1-1%201-3%204-4%209-5%205-1l-1%204c1%202%203%201%203-2%201-2%201-2%201%200l1%203c2%200%201%202-1%203l-3%201-2%201c-3%200-8%202-8%203l2%201%202%202c1%202%202%203%204%202%201-2%202-1%202%203%201%206%203%2012%205%2013l7%204c3%202%205%203%205%205l1%203h4c3-3%202%200-2%206s-6%207-6%205l1-2%202-1-2-1-3%201-2%203v-1c0-2%200-2-2-2-2%201-2%201-1-1l-1-2c-2%201-2%200-2-1l-1-2-4-1c-4-3-8-3-11-1l-2%203%201%2010c1%2011%201%2012%206%2010%202-1%203-4%203-8v-3l7%201h9l2%201c1%201%204-1%209-4%209-6%2010-7%2010-5l2%202c2%201%201-2-2-7-3-4-3-5-1-5l3%203%203%205%205%2013%203%208c3%206%203%206%207%206l18-2c2%200%203-1%203-3%201-1%200-2-1-2l-1-1%202-1%201-4c0-4%200-5-3-6-3-2-3-2-3-4v-5c-2-2-2-3%200-3%202%201%203%200%202-3%200-2%200-2-3%200s-6%201-4-2%200-4-3-1c-2%203-2%205%201%204l1%202c-1%203-9%204-11%201-1-2-2-2-4-2v3l1%201-2%202-1%203c-1%201%200%203%202%203l1%202c0%202-3%201-5-3-1-3-1-4%201-14l-1-3-2-1h-4l-3-1%202-1c3%200%208-5%208-9l-1-3-1%202c0%202-9%209-9%207v-4c1-2%201-3-1-5-4-2-4-3-1-3l2-2c0-2-1-2-3-2-4%200-5-1-3-2l3-5c1-3%201-3-1-5-2-1-2-2-1-4v-6c2-2%202-2%201-3-3-2-2-3%205-3l6%201-1%201v2l1%203%203%208c2%200%202-1%201-2-2-2-1-5%201-4v2c-1%202%202%203%205%202l3%201h3c3%201%205%201%205-2l2%201c4%203%206%203%207%200l1-4%201-2h-1l-4-2c-3-2-3-2-4%200h-3c-1-1-2-1-4%201h-4l-5-1c-2%200-3-1-3-2%201-2%201-3%2014-3h15l1-13v-11l-44-1c-40%200-44%200-45%202m31%2040c-8%203-17%208-17%2011h2c3-3%205-2%204%204%200%201%200%202%201%201h2v-6c1-3%203-4%203-1%201%202%203%203%205%201v-4c-1-1-1-2-2-1h-1v-1h6l2%201%203%202c2%201%202%201%202-1s0-3-2-3c-3%200-5-1-5-3h-3M4%20188v21l4%201%202%201%201%201h5c4%201%204%201%200-4l-4-10-2-6v-2c0-2%200-3-3-3l-3%201m98%2051c-2%201-2%202-1%203%202%203%20258%203%20259%200%202-4%204-4-129-4l-129%201m-75%209c-5%203-4%2011%201%2013%203%202%205%201%208-2%206-6-2-15-9-11m-13%201l-4%202c-4%205%203%2011%209%208%205-2%201-11-5-10m29%200c-3%203-4%207-1%209%205%204%2010%201%2010-4%200-4-6-7-9-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e81051c7b239ae85b6336468d8b8e8aa/ca0a1/3278-3003255229_6be9f9575f_m.webp 223w", "/static/e81051c7b239ae85b6336468d8b8e8aa/8ac56/3278-3003255229_6be9f9575f_m.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e81051c7b239ae85b6336468d8b8e8aa/853b2/3278-3003255229_6be9f9575f_m.jpg 223w", "/static/e81051c7b239ae85b6336468d8b8e8aa/09b79/3278-3003255229_6be9f9575f_m.jpg 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e81051c7b239ae85b6336468d8b8e8aa/09b79/3278-3003255229_6be9f9575f_m.jpg",
                "alt": "Spotify",
                "title": "Spotify",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Spotify`}</figcaption>{`
  `}</figure></p>
    <p>{`The idea of project soundtracks was born.`}</p>
    <p>{`I have four or five work playlists in Spotify. 8-bit music mixes has proven the best for coding, while `}<em parentName="p">{`The Electro Swing Revolution`}</em>{` seems best for writing. Blogging happens without a soundtrack to a well tuned radio station.`}</p>
    <p>{`Amazing results! Seriously.`}</p>
    <p>{`The biggest benefit is that context switching between projects is now almost effortless. As soon as a certain playlist starts my mind immediately jumps to its project - ideas star popping up, context is becoming clear and I can remember specific details I've worked on days ago.`}</p>
    <p>{`More importantly, other projects and concerns fade into the background instead of jumping all over each other, begging for my attention.`}</p>
    <p>{`Has any one else tried this before, or noticed similar effects?`}</p>
    <p>{`EDIT: some playlists:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://open.spotify.com/user/swizec/playlist/2k9u77IDuNxqIDghbpfOMP"
        }}>{`Super Mario`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://open.spotify.com/user/swizec/playlist/1qOmvq5TnFeeBR5MPEgQPX"
        }}>{`8bit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://open.spotify.com/user/swizec/playlist/3nih9fqf5MzWNlQrwLSzyP"
        }}>{`Tetris`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://open.spotify.com/user/swizec/playlist/6orkbDvW7gmPBJLxpeX8Uw"
        }}>{`Lyre Le Temps`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://open.spotify.com/user/crbwi/playlist/3ynTPnCy3kP1WhNuticSOK"
        }}>{`London Phillharmonic Orchestra - Greatest Video Game Music`}</a></li>
    </ul>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://suerowan.wordpress.com/2013/01/07/procrastination-aaarrggh/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/136334881_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://suerowan.wordpress.com/2013/01/07/procrastination-aaarrggh/"
        }}>{`Procrastination - aaarrggh!`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.collegemediainnovation.org/blog/2012/12/spinning-songs-and-sharing-music-digitally/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/132799927_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.collegemediainnovation.org/blog/2012/12/spinning-songs-and-sharing-music-digitally/"
        }}>{`Spinning songs and sharing music, digitally with Spotify`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bakadesuyo.com/2013/01/improving-mood-productive/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/136058146_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.bakadesuyo.com/2013/01/improving-mood-productive/"
        }}>{`Is improving your mood the best way to be more productive?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.flyerzone.co.uk/blog/get-more-done-a-guide-to-beating-procrastination/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/122214224_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.flyerzone.co.uk/blog/get-more-done-a-guide-to-beating-procrastination/"
        }}>{`Get more done: A guide to beating procrastination`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://teenmakerramblings.wordpress.com/2013/01/02/the-pomodoro-technique/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/135331036_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://teenmakerramblings.wordpress.com/2013/01/02/the-pomodoro-technique/"
        }}>{`The Pomodoro Technique`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a4e08a62-c4e5-4d6f-8473-40507b712d55",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      